import * as React from "react";
import { forwardRef } from "react";
const SvgIconSummary = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, viewBox: "0 0 14 14", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5 5v14h14V5zm1.273 1.273h11.454v11.454H6.273zm1.909 1.909v1.273h7.636V8.182zm0 3.182v1.273h7.636v-1.273zm0 3.182v1.273h4.636v-1.274z", "data-name": "icon/summary", transform: "translate(-5 -5)", fill: "#b6c2d0" }));
const ForwardRef = forwardRef(SvgIconSummary);
export { ForwardRef as ReactComponent };
